var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureUnplagActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3906 12.9883C12.6556 12.9883 7.92287 17.2852 7.22847 22.832H1.51562V25.6445H7.22856C7.92288 31.1913 12.6555 35.4883 18.3906 35.4883H19.7969C20.5759 35.4883 21.2031 34.8611 21.2031 34.082V31.2695H25.4219V28.457H21.2031V20.0195H25.4219V17.207H21.2031V14.3945C21.2031 13.6155 20.5759 12.9883 19.7969 12.9883H18.3906ZM38.0781 12.9883C37.2991 12.9883 36.6719 13.6155 36.6719 14.3945V17.207H39.4844V20.0195H36.6719V28.457H39.4844V31.2695H36.6719V34.082C36.6719 34.8611 37.2991 35.4883 38.0781 35.4883H46.5156V12.9883H38.0781Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureUnplagActive);
export default __webpack_public_path__ + "static/media/Feature_Unplag_active.719cc8019d369f1c337bea075be197e5.svg";
export { ForwardRef as ReactComponent };